/**
 * @author        shunzi <tobyzsj@gmail.com>
 * @date          2024-03-30 17:07:35
 */

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
